import moment from 'moment';
import {config} from "@/utils/config";

export default {
    data() {
        return {
            chartsUrl: config.chartsUrl,
            endpoints: {
                FREE_CHART: `${config.chartsUrl}/api/charts/free-chart`,
                RAVE_CHART: `${config.chartsUrl}/api/charts/`,
                SAVE_CHART: `${config.chartsUrl}/api/charts/single/save`,
                TRANSIT_CHART: `${config.chartsUrl}/api/charts/transit-chart`,
                UPDATE_TRANSIT_CHART: `${config.chartsUrl}/api/charts/transit-chart/update`,
                SINGLE_CHART: (chartId) => `${config.chartsUrl}/api/charts/${chartId}`,
                CONNECTION_CHART: `${config.chartsUrl}/api/charts/connection-chart`,
                SOLAR_RETURN: `${config.chartsUrl}/api/calculations/planetary/sun-return`,
                LUNAR_RETURN: `${config.chartsUrl}/api/calculations/planetary/moon-return`,
                IMPORT_CHART: `${config.chartsUrl}/api/charts/import`,
                IMPORT_STATUS: (importId) => `${config.chartsUrl}/api/charts/import-status/${importId}`,
            }
        }
    },

    methods: {
        // used to get sun returns for chart based on year.
        async getSolarReturn({
                                 year,
                                 position,
                                 date
                             }) {

            return this.axios.post(this.endpoints.SOLAR_RETURN, {
                year, position, date
            }).then((res) => {
                return res.data.timestamp;
            })
        },

        async getLunarReturns({
                                  year,
                                  position,
                                  date
                              }) {

            return this.axios.post(this.endpoints.LUNAR_RETURN, {
                year, position, date
            }).then((res) => {
                return res.data.map(x => x.timestamp);
            })
        },

        async createJustNowChart() {

            const now = moment.utc();

            const data = {
                timeInUtc: true,
                autosave: false,
                time: now.format(),
                name: `${this.$t('misc.justNow')} - ${now.format('LLL')} UTC`
            }

            return this.axios.post(this.endpoints.FREE_CHART, data).then(res => {
                return {
                    chart: res.data,
                    now: now
                }
            }).catch(e => {
                return e;
            })

        },

        async createRaveChart(data) {
            return this.axios.post(this.endpoints.RAVE_CHART, data).then(res => {
                return res.data;
            })
        },

        async createFreeChart(data) {
            return this.axios.post(this.endpoints.FREE_CHART, data).then(res => {
                return res.data;
            })
        },

        async updateRaveChart(chartId, data) {

            return this.axios.put(this.endpoints.SINGLE_CHART(chartId), data).then(res => {
                return res.data;
            })

        },

        async createConnectionChart(data) {
            return this.axios.post(this.endpoints.CONNECTION_CHART, data).then(res => {
                return res.data;
            })
        },

        async createTransitChart(data) {
            return this.axios.post(this.endpoints.TRANSIT_CHART, data).then(res => {
                return res.data;
            })
        },

        async updateTransitChart(data) {
            return this.axios.post(this.endpoints.UPDATE_TRANSIT_CHART, data).then(res => {
                return res.data;
            })
        },

        async saveTempChart(doc) {
            return this.axios.put(this.endpoints.SAVE_CHART, {chart: doc}).then(res => {
                return res.data
            })
        },
    }
}
